import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@mui/material';
import getStyles from '../../../utils/getStylesForTaskStatusSelect';

export default function ConfirmBox({ open, setOpen, onSave, onStatusChange }) {
  const [selectedStatus, setSelectedStatus] = useState('');
  const [hasSelected, setHasSelected] = useState(false);

  const handleSave = () => {
    if (hasSelected) {
      onSave(selectedStatus);
      setSelectedStatus(''); // Reset the radio button selection
      setHasSelected(false); // Reset the hasSelected state
      setOpen(false); // Close the dialog
    }
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setSelectedStatus(newStatus);
    setHasSelected(true);
    onStatusChange(newStatus);
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth={false}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          width: '480px',
        },
      }}
    >
      <DialogTitle sx={{ paddingBottom: 0 }}>
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          Update Status
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          row
          value={selectedStatus}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            gap: '8px',
          }}
          onChange={handleStatusChange}
        >
          <FormControlLabel
            value="In Progress"
            control={<Radio />}
            label={<Box sx={{ ...getStyles('In Progress'), padding: '2px 8px', borderRadius: '4px' }}>In Progress</Box>}
          />
          <FormControlLabel
            value="Completed"
            control={<Radio />}
            label={<Box sx={{ ...getStyles('Completed'), padding: '2px 8px', borderRadius: '4px' }}>Completed</Box>}
          />
          <FormControlLabel
            value="Blocked"
            control={<Radio />}
            label={<Box sx={{ ...getStyles('Blocked'), padding: '2px 8px', borderRadius: '4px' }}>Blocked</Box>}
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSave} color="primary" disabled={!hasSelected}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
